import { hMacAjax } from '../../httpService';
import { userCenterAPI } from '@/httpService/serviceApi';

export const url = {
    checkStatus: `${userCenterAPI}/api/user/business/validate`,
    projectList: `${userCenterAPI}/api/user/course/projects`,
    welcome: `${userCenterAPI}/api/user/recommend/welcome`
};

//获取课件校验状态
export function handleCheckStatus(data) {
    return hMacAjax.post(url.checkStatus, data);
}
//获取项目列表
export function handleGetProjectList(data) {
    return hMacAjax.get(url.projectList, data);
}
//获取欢迎语
export function handleWelcome(data) {
    return hMacAjax.get(url.welcome, data);
}
